import { render } from "./NoResultComponent.vue?vue&type=template&id=060cbefd"
import script from "./NoResultComponent.vue?vue&type=script&lang=js"
export * from "./NoResultComponent.vue?vue&type=script&lang=js"

import "./NoResultComponent.vue?vue&type=style&index=0&id=060cbefd&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__